<template>
  <v-dialog hideOverlay v-bind="$attrs" v-model="updateDialog" fullscreen :scrollable="false">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on"><slot name="activator"></slot></div>
    </template>
    <v-card class="d-flex flex-column">
      <v-toolbar max-height="65px" class="dialog-header" dark color="primary">
        <slot name="header"></slot>
        <div class="flex-grow-1 d-flex justify-end">
          <v-btn icon @click="updateDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-toolbar>
      <v-card-text class="py-0 flex-grow-1 d-flex align-center">
        <v-container fluid>
          <v-row>
            <v-col>
              <slot name="modal-content"></slot>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <slot name="actions"></slot>
        <v-btn text @click="updateDialog = false"> {{ getCloseMsg }} </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {}
  },
  props: {
    // Etat de la modale : ouverte ou non
    value: {
      type: Boolean,
      default: () => false,
    },
    // Texte du bouton Fermer
    closeMsg: {
      type: String,
      default: () => "",
    },
  },
  methods: {},
  computed: {
    /**
     * Récupère l'état de la modale (ouverte ou non ) ou la met à jour.
     */
    updateDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    getCloseMsg(){
      return this.closeMsg || this.$vuetify.lang.t('$vuetify.closeText')
    }
  },
}
</script>

<style lang="scss">
.dialog-header .v-toolbar__content {
  width: 100%;
}
</style>
